const FASTLANE_FEATURE_UUIDS = {
  PACKAGE: '4ba89d2a-e2a2-4187-9f1b-e0fc3320e5b8',
  DEPLOYMENT: '0e4d8f56-80f7-4a0b-b873-17038a8d4b08',
};

export default FASTLANE_FEATURE_UUIDS;
